import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarAction({ className, children }) {
    return <div className={cn('shrink-0 text-right w-[88px]', className)}>{children}</div>;
}

SnackbarAction.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
